import { CLOSING_PACKAGE_TASK_TYPE } from '../workspace/closingPackageTaskTypes';

export type ConfirmClientReceiptTaskLike = {
  taskType: string;
  status: string;
  dueDate?: string | null;
};

export type ConfirmClientReceiptTaskDisplay = {
  estimatedReceiptAtLabel: string;
  statusLabel: string;
  statusColor: 'processing' | 'error' | 'default';
};

function startOfLocalDay(value: Date): Date {
  const day = new Date(value);
  day.setHours(0, 0, 0, 0);
  return day;
}

function formatDateRu(value: Date | null): string {
  if (!value || Number.isNaN(value.getTime())) {
    return '—';
  }

  return value.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function isConfirmClientReceiptTask(taskType: string | null | undefined): boolean {
  return String(taskType || '').trim().toUpperCase() === CLOSING_PACKAGE_TASK_TYPE.CONFIRM_CLIENT_RECEIPT;
}

export function resolveConfirmClientReceiptTaskDisplay(
  task: ConfirmClientReceiptTaskLike,
  now: Date = new Date(),
  estimatedReceiptAt?: string | null
): ConfirmClientReceiptTaskDisplay {
  const dueFromTask = task.dueDate ? new Date(task.dueDate) : null;
  const dueFromProjection = estimatedReceiptAt ? new Date(estimatedReceiptAt) : null;
  const estimatedDate =
    dueFromProjection && !Number.isNaN(dueFromProjection.getTime())
      ? dueFromProjection
      : dueFromTask;

  const status = String(task.status || '').trim().toUpperCase();
  const overdueByStatus = status === 'OVERDUE';
  const overdueByDate =
    estimatedDate != null &&
    !Number.isNaN(estimatedDate.getTime()) &&
    startOfLocalDay(estimatedDate).getTime() < startOfLocalDay(now).getTime();

  const isOverdue = overdueByStatus || overdueByDate;

  return {
    estimatedReceiptAtLabel: formatDateRu(estimatedDate),
    statusLabel: isOverdue ? 'Просрочено' : 'Ожидается',
    statusColor: isOverdue ? 'error' : 'processing',
  };
}
